import {Component, OnInit} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {locale, loadMessages} from 'devextreme/localization';

@Component({
   selector: 'app-root',
   templateUrl: './app.component.html',
   styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
   private esMessages = require('devextreme/localization/messages/es.json');
   
   public title = 'Bagó Integrado';
   
   ngxConfig =
     {
        'bgsColor': '#902676',
        'bgsOpacity': 1,
        'bgsPosition': 'bottom-right',
        'bgsSize': 60,
        'bgsType': 'square-jelly-box',
        'blur': 5,
        'delay': 0,
        'fgsColor': '#902676',
        'fgsPosition': 'center-center',
        'fgsSize': 100,
        'fgsType': 'square-jelly-box',
        'gap': 24,
        'logoPosition': 'bottom-center',
        'logoSize': 80,
        'logoUrl': 'assets/images/isotipo-bago-transparente.png',
        'masterLoaderId': 'master',
        'overlayBorderRadius': '0',
        'overlayColor': 'rgba(40, 40, 40, 0.8)',
        'pbColor': '#902676',
        'pbDirection': 'ltr',
        'pbThickness': 3,
        'hasProgressBar': true,
        'text': 'Espere por favor...',
        'textColor': '#FFFFFF',
        'textPosition': 'center-center',
        'maxTime': -1,
        'minTime': 500
     };
   
   // ngxConfig =
   //   {
   //      'loaderid': 'loader-1',
   //      'bgsColor': '#902676',
   //      'bgsOpacity': 50,
   //      'bgsPosition': 'bottom-right',
   //      'bgsSize': 0,
   //      'bgsType': 'square-jelly-box',
   //      'blur': 5,
   //      'fgsColor': '#902676',
   //      'fgsPosition': 'center-center',
   //      'fgsSize': 60,
   //      'fgsType': 'chasing-dots',
   //      'gap': 24,
   //      'logoPosition': 'center-center',
   //      'logoSize': 200,
   //      'logoUrl': 'assets/images/logo-bago.png',
   //      'masterLoaderId': 'master',
   //      'overlayBorderRadius': '0',
   //      'overlayColor': 'rgba(40, 40, 40, 0)',
   //      'pbColor': '#902676',
   //      'pbDirection': 'ltr',
   //      'pbThickness': 6,
   //      'hasProgressBar': true,
   //      'text': 'Espere por favor...',
   //      'textColor': '#FFFFFF',
   //      'textPosition': 'center-center',
   //      'threshold': 500
   //   };
   
   // ngxConfig =
   //   {
   //      "bgsColor": "#902676",
   //      "bgsOpacity": 50,
   //      "bgsPosition": "bottom-right",
   //      "bgsSize": 60,
   //      "bgsType": "ball-spin-clockwise",
   //      "blur": 5,
   //      "fgsColor": "#902676",
   //      "fgsPosition": "center-center",
   //      "fgsSize": 60,
   //      "fgsType": "chasing-dots",
   //      "gap": 24,
   //      "logoPosition": "center-center",
   //      "logoSize": 200,
   //      "logoUrl": "assets/images/logo-bago.png",
   //      "masterLoaderId": "master",
   //      "overlayBorderRadius": "0",
   //      "overlayColor": "rgba(40,40,40,0)",
   //      "pbColor": "#902676",
   //      "pbDirection": "ltr",
   //      "pbThickness": 6,
   //      "hasProgressBar": true,
   //      "text": "Espere por favor....",
   //      "textColor": "#FFFFFF",
   //      "textPosition": "center-center",
   //      "threshold": 500
   //   }
   
   constructor(private router: Router) {
   }
   
   ngOnInit() {
      this.router.events.subscribe((evt) => {
         if (!(evt instanceof NavigationEnd)) {
            return;
         }
         
         this.configLanguageDevExtreme();
         window.scrollTo(0, 0);
      });
   }
   
   private configLanguageDevExtreme() {
      loadMessages(this.esMessages);
      locale(navigator.language);
   }
}
